import { fromString } from "@bounce/date"
import type { PostCardProps } from "@bounce/web-components"

import type { FormattedBlogPostPreview } from "@/libs/prismic/types"

/**
 * Map a blog post to a post card props
 */
export const blogPostToPostCard = (blogPost: FormattedBlogPostPreview): PostCardProps => ({
  title: blogPost.title,
  excerpt: blogPost.excerpt,
  image: blogPost.image,
  href: blogPost.url,
  date: fromString(blogPost.datePublished).toFormat("d MMMM"),
  author: blogPost.author,
})

/**
 * Check if a keyword is included in a blog post
 */
export const blogPostIncludes = (blogPost: FormattedBlogPostPreview, keywords: string) => {
  const text = keywords.toLowerCase()
  const title = blogPost.title.toLowerCase()
  const excerpt = blogPost.excerpt.toLowerCase()

  return title.includes(text) || excerpt.includes(text)
}
